"use client";

import { Button } from "@ui/components/core/Button";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import { clsx } from "clsx";
import { useTranslations } from "next-intl";
import IconCallOutgoingFilled from "@ui/central-icons/icons/IconCallOutgoingFilled";
import IconCallIncomingFilled from "@ui/central-icons/icons/IconCallIncomingFilled";
import IconCallCancelFilled from "@ui/central-icons/icons/IconCallCancelFilled";

interface PillButtonProps {
  onClick: () => void;
  label?: string | null;
  className?: string;
}

export function CallAgentPillButton({ onClick, label, className }: PillButtonProps) {
  const t = useTranslations("ClientKeys.hero_agent.views.agent_info");
  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-gap-3'>
      <Button
        variant='primary'
        size='pill-xl'
        icon={<IconCallOutgoingFilled className={clsx(iconStrokeFix, "tw-text-white tw-size-6")} />}
        onClick={onClick}
        className={className}
      />
      <span className='tw-text-gray-500 tw-type-2xs md:tw-type-xs'>{label || t("call_agent")}</span>
    </div>
  );
}

export function GetCallPillButton({ onClick, label, className }: PillButtonProps) {
  const t = useTranslations("ClientKeys.hero_agent.views.agent_info");
  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-gap-3'>
      <Button
        variant='elevated'
        size='pill-xl'
        icon={<IconCallIncomingFilled className={clsx(iconStrokeFix, "tw-text-black tw-size-6")} />}
        onClick={onClick}
        className={className}
      />
      <span className='tw-text-gray-500 tw-type-2xs md:tw-type-xs'>{label || t("get_call")}</span>
    </div>
  );
}

export function EndCallPillButton({ onClick, label, className }: PillButtonProps) {
  const t = useTranslations("ClientKeys.hero_agent.views.agent_info");
  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-gap-3'>
      <Button
        variant='primary'
        size='pill-xl'
        icon={<IconCallCancelFilled className={clsx(iconStrokeFix, "tw-text-white tw-size-6")} />}
        onClick={onClick}
        className={className}
      />
      <span className='tw-text-gray-500 tw-type-2xs md:tw-type-xs'>{label || t("end_call")}</span>
    </div>
  );
}
